import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-create-discussion',
  templateUrl: './create-discussion.component.html',
  styleUrls: ['./create-discussion.component.sass']
})
export class CreateDiscussionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
